import React from "react";
import { Link } from "react-router-dom";
import { APP } from "@/config";
import { FOUNDER } from "@/landingContent";
import LandingFooter from "@/components/LandingFooter";
import { ArrowLeft } from "lucide-react";

const CONTENT = {
  privacy: {
    title: "Privacy Policy",
    draft: true,
    body: [
      "This is placeholder privacy content for NumberSense. It describes, in plain language, how a parent-managed account works: parents create the account and provide consent, children use only a first name or nickname, we show no ads and never sell family data, and the AI tutor is restricted to math.",
      "Final privacy text — including data retention periods, sub-processors, COPPA specifics and parental rights — must be drafted and reviewed by legal counsel before launch.",
    ],
  },
  terms: {
    title: "Terms of Service",
    draft: true,
    body: [
      "This is placeholder terms content for NumberSense covering acceptable use, account responsibilities, subscription and cancellation, and limitation of liability.",
      "Final terms must be drafted and reviewed by legal counsel before launch.",
    ],
  },
  about: {
    title: "About NumberSense",
    draft: false,
    body: [
      "NumberSense is an adaptive K-12 math platform for grades 3–8 that finds the real gaps, builds a prerequisite-aware mastery plan, and coaches with a Socratic AI tutor that never just gives the answer.",
      `Founder: ${FOUNDER.name} — ${FOUNDER.credentials}.`,
      FOUNDER.story,
      "For Schools & Homeschoolers: [PLACEHOLDER — describe bulk/classroom options and how to get in touch].",
    ],
  },
  contact: {
    title: "Contact",
    draft: false,
    body: [
      "We'd love to hear from you.",
      "Email: [CONTACT EMAIL]",
      "Mailing address: [BUSINESS ADDRESS]",
    ],
  },
};

export default function StaticPage({ slug }) {
  const page = CONTENT[slug] || CONTENT.about;
  return (
    <div className="min-h-screen bg-[var(--ns-bg)] flex flex-col">
      <header className="max-w-3xl w-full mx-auto px-5 py-5">
        <Link to="/" className="inline-flex items-center gap-2 text-sm font-semibold text-[var(--ns-primary)]" data-testid="back-home">
          <ArrowLeft size={16} /> {APP.name}
        </Link>
      </header>
      <main className="max-w-3xl w-full mx-auto px-5 py-8 flex-1" data-testid={`static-page-${slug}`}>
        <h1 className="font-head text-4xl font-bold text-[var(--ns-text)]">{page.title}</h1>
        {page.draft && (
          <div className="mt-5 rounded-[var(--ns-radius)] border-2 border-[#E0A93D] bg-[#FBF0DA] text-[#8A5E15] px-4 py-3 font-semibold" data-testid="draft-notice">
            DRAFT — to be reviewed by legal counsel before launch.
          </div>
        )}
        <div className="mt-6 space-y-4">
          {page.body.map((p, i) => (
            <p key={i} className="text-[var(--ns-muted)] leading-relaxed">{p}</p>
          ))}
        </div>
      </main>
      <LandingFooter />
    </div>
  );
}
